export const USER_TYPE_ABBREVIATIONS = {
	AUTHENTICATED_ACTIVE_SHARED_SERVICES_USER: 'ssu_a',
	AUTHENTICATED_INACTIVE_SHARED_SERVICES_USER: 'ssu_i',
	AUTHENTICATED_ACTIVE_LEGACY_USER: 'osu_a',
	AUTHENTICATED_INACTIVE_LEGACY_USER: 'osu_i',
	SHARED_SERVICES_USER: 'ssu',
	LEGACY_USER: 'osu',
};

/**
 * Enum for different types of account statuses.
 * @readonly
 * @enum {string}
 */
export const ACCOUNT_STATUS = {
	ABCMOUSE: 'abcmouse',
	ACTIVE: 'active',
	INACTIVE: 'inactive',
	/**
	 * @description The user has an active auxiliary subscription such as assessments, but has no active primary subscription.
	 */
	AUXILIARY_ONLY_ACTIVE: 'auxiliary_only_active',
	FREE: 'free',
	NONE: 'none',
};

/**
 * Enum for different types of account types.
 * @readonly
 * @enum {string}
 */
export const ACCOUNT_TYPES = {
	ACTIVE_SHARED_SERVICES_USER: 'ssu_a',
	INACTIVE_SHARED_SERVICES_USER: 'ssu_i',
	ACTIVE_LEGACY_USER: 'osu_a',
	INACTIVE_LEGACY_USER: 'osu_i',
	SHARED_SERVICES_USER: 'ssu',
	LEGACY_USER: 'osu',
};
